import "swiper/css";
import { DecisionCard } from "../DecisionCard";
import { DecisionPreview } from "../DecisionPreview";
import { StyledSlider } from "../../../styles/StyledSlider";
import { Swiper, SwiperSlide } from "swiper/react";
import { useCallback, useState } from "react";
import Modal from "../../Modal";
import PropTypes from "prop-types";

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		minWidth: "50rem",
		maxWidth: "50rem",
		padding: "25px",
		maxHeight: "70vh",
		overflowY: "auto",
		background: "#F7F8F9",
		zIndex: 20,
	},
};

export default function DecisionSlider({ data, clearSearchResults, decisionBody = false }) {
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [modalId, setModalId] = useState(null);

	const openModal = useCallback(
		(id) => {
			if (id !== modalId) setModalId(id);
			setModalIsOpen(true);
		},
		[modalId]
	);

	const closeModal = useCallback(() => {
		setModalIsOpen(false);
	});

	return (
		<>
			{data.length > 0 ? (
				<StyledSlider decisionBody={decisionBody}>
					<Swiper spaceBetween={0} slidesPerView={"auto"} grabCursor={true}>
						{data.map((decision) => {
							return (
								<SwiperSlide key={decision.id}>
									<DecisionCard clearSearchResults={clearSearchResults} data={decision} decisionsList={data} openModal={openModal} />
								</SwiperSlide>
							);
						})}
					</Swiper>
				</StyledSlider>
			) : (
				"No decisions found"
			)}

			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				style={customStyles}
				appElement={document.getElementById("app")}
				role="overviewEdit-modal"
			>
				<DecisionPreview clearSearchResults={clearSearchResults} closeModal={closeModal} decisionId={modalId} decisionsList={data} />
			</Modal>
		</>
	);
}

DecisionSlider.propTypes = {
	data: PropTypes.array,
	clearSearchResults: PropTypes.bool,
	decisionBody: PropTypes.bool,
};
